module.exports = __webpack_public_path__ + "img/fossil2Img2.f3c7af5a.jpg";